module.exports = __webpack_public_path__ + "img/中信银行@2x.0857217a.png";